<template>
  <div>
    <div class="form-group">
      <label for="client">Client</label>
      <v-select
          id="client"
          :options="clientOptions"
          v-model="client"
          :reduce="client => client.id"
          label="label"
          :placeholder="placeholder"
          @input="updateApps"
      ></v-select>
    </div>
    <div class="form-group">
      <label for="app">App</label>
      <v-select
          id="app"
          :options="appOptions"
          v-model="app"
          label="name"
          :placeholder="placeholder"
          :reduce="app => Number(app.id)"
      ></v-select>
    </div>
    <input type="hidden" name="client_id" :value="client">
    <input type="hidden" name="app_id" :value="app">
  </div>
</template>

<script>
export default {
  name: "ClientAppSelector",
  props: {
    clients: {
      type: Object,
      required: true
    },
    allApps: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: "-- Bitte wählen --"
    },
    initialClientId: {
      type: [String, Number],
      default: ''
    },
    initialAppId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      client: this.initialClientId ? Number(this.initialClientId) : '',
      app: this.initialAppId ? Number(this.initialAppId) : '',
      appOptions: []
    };
  },
  computed: {
    clientOptions() {
      return Object.entries(this.clients).map(([id, name]) => ({
        id: Number(id),
        label: `${name} (ID: ${id})`
      }));
    }
  },
  methods: {
    updateApps() {
      const clientId = Number(this.client);
      const filtered = this.allApps.filter(
          app => Number(app.client_id) === clientId
      );
      this.appOptions = filtered.map(app => ({
        ...app,
        name: `${app.name} (ID: ${app.id})`
      }));
      const exists = filtered.some(app => Number(app.id) === Number(this.app));
      if (!exists) {
        this.app = '';
      }
    }
  },
  mounted() {
    if (this.client) {
      this.updateApps();
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
}
</style>